// Ported from @Corim/architecture-frontend. A controlled input whose value
// lives in the global Dispatch state under 'Textbox.<id>'.
import React from 'react'
import _ from 'lodash'
import { map, switchMap, take } from 'rxjs/operators'

import Dispatch from './Dispatch'
import BaseComponent from './BaseComponent'

const getDispatchIds = (id) => {
  const idArray = id.split('.')
  let idString = idArray.reduce((acc, next, index) => index + 1 !== idArray.length ? acc + '.' + next : acc, '')
  idString = idString ? idString : ''
  return {
    idString,
    idValue: idArray[idArray.length - 1],
  }
}

// Drop an unmounted textbox's value from state to avoid leaking memory
Dispatch.getAction('Textbox.remove')
  .pipe(
    map(e => getDispatchIds(e)),
    switchMap(ids => Dispatch.getState('Textbox' + ids.idString)
      .pipe(
        take(1),
        map((state) => {
          const { [ids.idValue]: value, ...newState } = state
          return newState
        }),
        map(newState => ({ ids, state: newState }))
      )),
  )
  .subscribe(e => {
    Dispatch.nextState('Textbox' + e.ids.idString, e.state)
    Dispatch.nextState('TextboxIds' + e.ids.idString, e.state)
  })

const types = {
  tel: 'tel',
  zip: 'text',
  text: 'text',
  email: 'email',
  checkbox: 'checkbox',
  password: 'password',
}

const parseType = (type, value) => {
  let newValue = value
  if (type === 'zip') {
    const tempValue = value.replace(/\D+/g, '')
    newValue = tempValue.substring(0, 5)
  }
  return newValue
}

class Textbox extends React.Component {
  componentDidMount() {
    const defaultValue = this.props.defaultValue
    const dispatchIds = getDispatchIds(this.props.id)
    const substituteValue = types[this.props.type] === 'checkbox' ? false : ''
    if (_.isNil(this.props.value)) {
      Dispatch.mergeState('Textbox' + dispatchIds.idString, { [dispatchIds.idValue]: defaultValue ? defaultValue : substituteValue })
    }
    Dispatch.mergeState('TextboxIds' + dispatchIds.idString, { [dispatchIds.idValue]: true })
  }

  componentWillUnmount() {
    Dispatch.nextAction('Textbox.remove', this.props.id)
  }

  render() {
    if (!this.props.id) {
      throw new Error('Textbox missing ID. ID is required.')
    }
    const id = this.props.id
    const className = this.props.className
    const value = this.props.value
    const style = this.props.style
    const onKeyDown = this.props.onKeyDown
    const onBlur = this.props.onBlur
    const placeholder = this.props.placeholder
    const type = this.props.type ? this.props.type : 'text'

    const dispatchIds = getDispatchIds(id)
    return (
      <input
        type={types[type] ? types[type] : 'text'}
        key={id}
        style={style}
        value={value}
        placeholder={placeholder}
        className={className}
        onBlur={e => onBlur ? onBlur(e) : null}
        onKeyDown={e => onKeyDown ? onKeyDown(e) : null}
        onChange={e => {
          const newValue = (type === 'checkbox') ? e.target.checked : e.target.value
          const update = parseType(type, newValue)
          Dispatch.nextAction('Textbox.' + id + '.update', update)
          Dispatch.mergeState('Textbox' + dispatchIds.idString, { [dispatchIds.idValue]: update })
        }}
      />
    )
  }
}

export default (props) => <BaseComponent
  Component={Textbox}
  store={props.stream ?
    props.stream
    :
    Dispatch.getState('Textbox.' + props.id)
      .pipe(
        map(e => ({ value: e }))
      )
  } {...props} />
